module.exports = __webpack_public_path__ + "img/icn_storage_distribution5.4afac47f.png";